import styled from "styled-components";
import { Row as AntRow } from "antd";

export const RootContainer = styled.div`
  padding: 0 16px;
`;

export const Title = styled.div`
  padding-top: 20px;
  padding-bottom: 16px;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #000000;
  display: flex;
  align-items: center;

  svg {
    padding-right: 5px;
  }

  @media screen and (max-width: 425px) {
    padding-left: 6px;
  }

  @media screen and (max-width: 375px) {
    padding-left: 0;
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media screen and (max-width: 325px) {
    grid-gap: 6px;
    padding: 6px 0px;
  }
`;

export const Text = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #464646;
  text-align: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 100%;
  max-width: 64px;
  border-radius: 8px;
  aspect-ratio: 1;
  object-fit: contain;

  @media screen and (max-width: 325px) {
    max-width: 55px;
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Row = styled(AntRow)`
  background: #E1F0FF;
  padding: 16px 0px;
  border-radius: 10px;
`;